import { Text } from '@loadsmart/loadsmart-ui'

import { ErrorIcon } from './Bid.styles'
import { BidDialogMessage } from './BidDialogMessage'

export function BidError({ onClose }) {
  return (
    <BidDialogMessage header="Something Went Wrong" Icon={<ErrorIcon />} onClose={onClose}>
      <Text variant="heading-md-bold" as="p">
        The bidding process failed
      </Text>
      <Text as="p">We couldn't process your bid,</Text>
      <Text as="p">please try again in a minute</Text>
    </BidDialogMessage>
  )
}
